import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {HomeComponent} from './home.component';
import {KontaktComponent} from './kontakt.component';
import {ImpressumComponent} from './impressum.component';
import {KitereisenComponent} from './kitereisen.component';
import {DatenschutzComponent} from './datenschutz.component';
import {WintersportreisenComponent} from './wintersportreisen.component';
import {DownloadComponent} from './download.component';

const routes: Routes = [
  { path: '',  component: HomeComponent },
  { path: 'admin', loadChildren: () => import('../admin/admin.module').then(mod => mod.AdminModule)},
  { path: 'datenschutz', component: DatenschutzComponent },
  { path: 'download', component: DownloadComponent },
  { path: 'impressum', component: ImpressumComponent },
  { path: 'kitereisen', component: KitereisenComponent },
  { path: 'kontakt', component: KontaktComponent },
  { path: 'wintersportreisen',  component: WintersportreisenComponent },
  { path: '**', component: HomeComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
